
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 92.38 89.62"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"レイヤー 2"}},[_c('g',{attrs:{"data-name":"レイヤー 9"}},[_c('path',{attrs:{"fill":"#ddceb3","stroke":"#89620c","stroke-miterlimit":"10","stroke-width":"5.92","d":"M2.96 2.96h86.46v83.69H2.96z"}}),_c('path',{attrs:{"d":"M41.44 12.85l8.84 1q-.91 3.7-2.14 7.6h23.59V73.1h-8.64v-3h-33.8v3h-8.65V21.43H39a77.29 77.29 0 002.44-8.58zm21.65 22.81v-7.15h-33.8v7.15zm-33.8 13.72h33.8v-7.22h-33.8zm0 13.91h33.8v-7.41h-33.8z","fill":"#84183f"}})])])])
          )
        }
      }
    